module.exports = __webpack_public_path__ + "img/vitara.de02fab2.png";